import React from "react";
import BookList from "./components/booklist";

function App() {
    return (
        <div>
            <BookList />
            <footer className="footer">
                <p>© 2024 Harry Potter Fan Club. All Rights Reserved.</p>
            </footer>
        </div>
    );
}

export default App;
